import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import {MatDialogModule} from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared.module';
import {MatTabsModule} from '@angular/material/tabs';
import { NgxMaskModule } from 'ngx-mask';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';


import { ContactRoutingModule } from './contact-routing.module';
import { ContactComponent } from './contact.component';
import { ContactTableComponent } from './contact-table/contact-table.component';
import { ChangeContactStatusModalComponent } from './change-contact-status-modal/change-contact-status-modal.component';


@NgModule({
  declarations: [
    ContactComponent,
    ContactTableComponent,
    ChangeContactStatusModalComponent
  ],
  imports: [
    CommonModule,
    ContactRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    MatDialogModule,
    SharedModule,
    MatTabsModule,
    NgxMaskModule,
    MatTooltipModule,
    MatSelectModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactModule { }
